import {NgOptimizedImage} from "@angular/common";
import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {Router} from "@angular/router";
import {LoggerService} from "../../services/logger/logger-service/logger.service";
import {ScreenSizeService} from "../../services/screen-size-service/screen-size.service";
import {NavComponent} from "../nav/nav.component";
import {environment} from "../../../../environments/environment";

/**
 * Header containing responsive nav menu.
 */
@Component({
  selector: 'app-header',
  imports: [
    NgOptimizedImage,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NavComponent,
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  // Injectables
  logger = inject(LoggerService);
  screenSizeService = inject(ScreenSizeService);
  router = inject(Router);

  // Signals
  screenSize = this.screenSizeService.screenSize;

  // isTablet
  isDesktop(): boolean {
    return this.screenSize() === "desktop";
  }

  protected readonly environment = environment;
}
